import React from "react";
import Loginpage from "../components/login/Loginpage.jsx";
import Backbutton from "../components/Backbutton";

function Login() {
    return (
        <>
            <Backbutton />
            <Loginpage />
        </>
    );
}

export default Login;
